<template>
    <div id="tab-sub-menu">
        <div class="row">
            <div class="item col-6"
                :class="{'active': tabActive == 'earn'}" @click="clickTab('earn')">
                {{lblTab.earn}}
            </div>
            <div class="item col-6"
                :class="{'active': tabActive == 'used'}" @click="clickTab('burn')">
                {{lblTab.used}}
            </div>
        </div>
    </div>
</template>
<script>
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'tab-sub-menu',
    props: {
        lblTab: Object,
        tabActive: String,
        theme: String,
    },
    data: function () {
        return {
            trackingService: new TrackingService(this),
            trackingScreenName: 'history'
        };
    },
    created: function () {
        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        clickTab: function(page) {
            this.bzbTracking(page)
            if (this.tabActive == page) {
                return;
            }else{
                this.$router.push('/history/'+page);
            }
        },
        bzbTracking: function(page) {
            var trackingEventCategory = 'history_page'
            var eventName = ''
            if(page == 'earn') {
                eventName = 'click_history_earn_point'
            } else if (page == 'burn') {
                eventName = 'click_history_burn_point'
            }
            this.trackingService.event(trackingEventCategory, eventName, null, null)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

@mixin border-btn-tab($color) {
    border-bottom: 2px solid $color;
}

#tab-sub-menu{
    padding: 0px 40px;
    margin-top: 16px;
    font-size: 1.5rem;
    font-family: $regular;
    text-align: center;
    line-height: normal;

    @media (max-width: $max-width-mini-mobile) {
        font-size: 1.5rem;
    }

    .item{
        color: $text-gray;
        padding: 10px 0;

        &.active {
            @include border-btn-tab($green-00987F);
            color: $green-00987F;
        }
    }
}
</style>
